import { CheckoutLoginStep } from '@components/Login/CheckoutLoginStep';
import { RedirectToStatusOrShowOfferStepWrapper } from '@components/TireOffer/RedirectToStatusOrShowOfferStepWrapper';
import { TireOfferPaymentSummary } from '@components/TireOffer/TireOfferPaymentSummary';
import { getTireOfferTotal } from '@components/TireOffer/tireOfferTotal';
import { plural } from '@lingui/core/macro';
import { invalidateQueryExactMatch, URLKeys } from 'noddi-async';
import { customerRoutes, formatCurrencyAmount } from 'noddi-util';
import { useTireOfferStore } from '../../../stores/tireOfferStore';

export const TireOfferLogin = () => {
  const { selectedQuoteItem } = useTireOfferStore();

  return (
    <RedirectToStatusOrShowOfferStepWrapper>
      {(data) => {
        const quoteItemTires = selectedQuoteItem?.quoteItemTires ?? [];
        const tireCount = quoteItemTires.reduce((sum, tire) => sum + (tire.quantitySelected ?? 0), 0);

        return (
          <CheckoutLoginStep
            nextPath={customerRoutes.tireOfferSummary.getPath({ slug: data.slug })}
            opensUserGroupPicker
            // The offer read while logged out carries no saved address; the summary needs the logged-in read.
            onLoggedIn={() =>
              void invalidateQueryExactMatch({
                urlKey: URLKeys.getCarTireQuoteBySlug,
                input: { carTireQuoteSlug: data.slug }
              })
            }
            order={
              selectedQuoteItem
                ? {
                    description: plural(tireCount, { one: '# tire', other: '# tires' }),
                    total: formatCurrencyAmount({
                      money: { amount: getTireOfferTotal(quoteItemTires, data.genericItems) }
                    }),
                    details: (
                      <TireOfferPaymentSummary
                        quoteItemTires={quoteItemTires}
                        genericItems={data.genericItems}
                        isStaggered={!!selectedQuoteItem.isStaggered}
                      />
                    )
                  }
                : undefined
            }
          />
        );
      }}
    </RedirectToStatusOrShowOfferStepWrapper>
  );
};
